import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import CompanyCard from "./CompanyCard";
import styles from "../styles.module.css";

const ViewAllUsers = () => {
  const { id } = useParams(); // Using the company id from the route
  const [companies, setCompanies] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchCompanies();
  }, []);

  const fetchCompanies = async () => {
    setIsLoading(true);
    setError("");
    try {
      const response = await axios.post(
        "https://casaahaanahotels.com/sb_showcompanyusers",
        { adminemail: "tjgraff@ttjrecruiting1.com" }
      );

      if (response.data && response.data.user_data) {
        setCompanies(response.data.user_data);
      } else {
        setError("Failed to fetch companies. Please try again.");
      }
    } catch (err) {
      setError("Failed to fetch companies. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.vcContainer}>
      <h1 className={styles.vcHeading}>All Companies</h1>
      {isLoading ? (
        <p>Loading...</p>
      ) : error ? (
        <p className={styles.vcerror}>{error}</p>
      ) : (
        <div className={styles.vcGrid}>
          {companies.map((company) => (
            <CompanyCard
              key={company.id}
              companyName={company.companyname}
              adminName={`${company.admin_first_name} ${company.admin_last_name}`}
              adminEmail={company.adminemail}
              imageFile={company.imageFile}
              id={company.id}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ViewAllUsers;